import React from 'react';
import { Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Button as SparkButton } from '@spark';
import { isRenderablePrimitive } from '@/features/datasets/utils/renderPreviewUtils';

const { Text } = Typography;


const FormatError = ({ title, onNeedHelpClick }) => (
    <span style={{ color: '#ff4d4f' }}>
        <strong>Can’t preview {title.toLowerCase()}:</strong> this file doesn’t match the expected format.{' '}
        Use <SparkButton variant="link" size="small" onClick={onNeedHelpClick} disabled={!onNeedHelpClick} style={{ padding: 0 }}>Need help?</SparkButton> to download an example template and compare your file structure.
    </span>
);

const isReactElement = (v) => {
    try {
        return React.isValidElement(v);
    } catch {
        return false;
    }
};


/**
 * Reusable component for displaying extracted content/example with consistent styling
 * Used in PromptTemplateStep and DatasetUploadStepsModal
 */
const ExtractedContentDisplay = ({ title, value, loading, onNeedHelpClick }) => (
    <div style={{ marginBottom: '16px' }}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            gap: '8px'
        }}>
            <Text style={{
                fontWeight: 400,
                color: '#222',
                fontSize: '14px',
                margin: 0
            }}>
                {title}:
            </Text>
        </div>
        <div style={{
            paddingLeft: '8px',
            color: '#595959',
            fontSize: '14px',
            lineHeight: '1.5',
            maxHeight: '150px',
            overflowY: 'auto',
            overflowX: 'hidden',
            wordBreak: 'break-word',
        }}
            className="optune-scrollbar"
        >
            {loading ? (
                <LoadingOutlined style={{ fontSize: '14px', color: '#8c8c8c' }} />
            ) : (
                (React.isValidElement(value) || isRenderablePrimitive(value)) ? (
                    value || <span style={{ color: '#8c8c8c', fontStyle: 'italic' }}>No {title.toLowerCase()} found</span>
                ) : (
                    <FormatError title={title} onNeedHelpClick={onNeedHelpClick} />
                )
            )}
        </div>
    </div>
);

export default ExtractedContentDisplay;

